import { render, staticRenderFns } from "./DT_Widgets.vue?vue&type=template&id=5d7730ef&scoped=true&"
import script from "./DT_Widgets.vue?vue&type=script&lang=js&"
export * from "./DT_Widgets.vue?vue&type=script&lang=js&"
import style0 from "./DT_Widgets.vue?vue&type=style&index=0&id=5d7730ef&prod&lang=css&"
import style1 from "./DT_Widgets.vue?vue&type=style&index=1&id=5d7730ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7730ef",
  null
  
)

export default component.exports